"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHostRecentCallLog = exports.createHostRecentCallLogProvider = void 0;
const factory_1 = require("./factory");
_a = (0, factory_1.createContextFactory)('HostRecentCallLog'), exports.createHostRecentCallLogProvider = _a[0], exports.useHostRecentCallLog = _a[1];
//# sourceMappingURL=call_log.js.map